/*
 * Infrastructure Management System - Frontend Entry Point
 * © 2025 DeskShare Inc. All rights reserved.
 * 
 * Delivered By: Claude (AI Development Assistant)
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
